// 性别映射
export const sexCnMap = [['0', '女'], ['1', '男']]
export const sexEnMap = [['0', 'Female'], ['1', 'Male']]

// 婚姻情况映射
export const maritalCnMap = [
  ['UNMARRIED', '未婚'],
  ['MARRIED', '已婚'],
  ['WIDOWED', '丧偶'],
  ['SEPARATED', '分居'],
  ['DIVORCED', '离婚']
]
export const maritalEnMap = [
  ['UNMARRIED', 'Unmarried'],
  ['MARRIED', 'Married'],
  ['WIDOWED', 'Widowed'],
  ['SEPARATED', 'Separated'],
  ['DIVORCED', 'Divorced']
]

export const guardianCnMap = [
  ['FATHER', '父亲'],
  ['MOTHER', '母亲'],
  ['BOTH', '两者都是'],
  ['OTHER', '其他']
]
export const guardianEnMap = [
  ['FATHER', 'Father'],
  ['MOTHER', 'Mother'],
  ['BOTH', 'Both'],
  ['OTHER', 'Other']
]

// 是否有美国签证或绿卡映射
export const hasUsVisaCnMap = [['true', '是'], ['false', '否']]
export const hasUsVisaEnMap = [['true', 'Yes'], ['false', 'No']]

// 是否健在映射
export const isVitalCnMap = [['1', '是'], ['0', '否']]
export const isVitalEnMap = [['1', 'Yes'], ['0', 'No']]

// 最高学历映射
export const highestDegreeCnMap = [
  ['HIGHSCHOOL', '大专/中专/高中'],
  ['UGD', '本科'],
  ['MASTER', '硕士'],
  ['PHD', '博士']
]
export const highestDegreeEnMap = [
  [
    'HIGHSCHOOL',
    'Junior College/ Technical Secondary School/ High School Diploma'
  ],
  ['UGD', "Bachelor's Degree"],
  ['MASTER', "Master's Degree"],
  ['PHD', 'Doctorate']
]

// 是否有兄弟姐妹映射
export const brotherCnMap = [['1', '是'], ['0', '否']]
export const brotherEnMap = [['1', 'Yes'], ['0', 'No']]

// 学校类型映射
export const schoolTypeCnMap = [['PUBLIC', '私立'], ['PRIVATE', '公立']]
export const schoolTypeEnMap = [['PUBLIC', 'Public'], ['PRIVATE', 'Private']]

// 课程体系映射
export const educationalSystemCnMap = [
  ['AP', 'AP班'],
  ['A_LEVEL', 'A-Level班'],
  ['IB', 'IB班'],
  ['OTS', '其他国际课程体系'],
  ['PHC', '普高班'],
  ['PHSC', 'A-普高特殊班']
]
export const educationalSystemEnMap = [
  ['AP', 'AP'],
  ['A_LEVEL', 'A-Level'],
  ['IB', 'IB'],
  ['OTS', 'Other international Test-based system'],
  ['PHC', 'Public high school'],
  ['PHSC', 'special class in public high school']
]

// GPA scale映射
export const GPAScaleCnMap = [
  ['FOUR_POINT_SYSTEM', '4'],
  ['FOUR_POINT_FIVE_SYSTEM', '4.5'],
  ['FIVE_POINT_SYSTEM', '5'],
  ['HUNDRED_MARK_SYSTEM', '100'],
  ['OTHER', '其他']
]
export const GPAScaleEnMap = [
  ['FOUR_POINT_SYSTEM', '4'],
  ['FOUR_POINT_FIVE_SYSTEM', '4.5'],
  ['FIVE_POINT_SYSTEM', '5'],
  ['HUNDRED_MARK_SYSTEM', '100'],
  ['OTHER', 'Other']
]

// 是否寄宿制学校映射
export const boardingInstitutionCnMap = [['true', '是'], ['false', '否']]
export const boardingInstitutionEnMap = [['true', 'Yes'], ['false', 'No']]

// 是否住校映射
export const applicantBoardCnMap = [['true', '是'], ['false', '否']]
export const applicantBoardEnMap = [['true', 'Yes'], ['false', 'No']]
// 年级映射
export const gradeCnMap = [
  ['9', '9'],
  ['10', '10'],
  ['11', '11'],
  ['12', '12'],
  ['Post-graduate', 'Post-graduate']
]
export const gradeEnMap = [
  ['9', '9'],
  ['10', '10'],
  ['11', '11'],
  ['12', '12'],
  ['Post-graduate', 'Post-graduate']
]
// 奖项级别映射
export const awardLevelCnMap = [
  ['INTERNATIONAL', '国际级'],
  ['NATIONAL', '国家级'],
  ['REGIONAL', '区域级'],
  ['SCHOOL', '校级']
]
export const awardLevelEnMap = [
  ['INTERNATIONAL', 'international'],
  ['NATIONAL', 'national'],
  ['REGIONAL', 'regional'],
  ['SCHOOL', 'school']
]
// 活动类型映射
export const activityTypeCnMap = [
  ['ACADEMY', 'academy'],
  ['ART', 'ART'],
  ['ATHLETICS_CLUB', 'Athletics:Club'],
  ['ATHLETICS_JV', 'Athletics:JV/Varsity'],
  ['CAREERORIENTED', 'Career Oriented'],
  ['VOLUNTEE', 'Community Service (Volunteer)'],
  ['COMPUTER_OR_TECHNOLOGY', 'Computer/Technology'],
  ['CULTURAL', 'Cultural'],
  ['DANCE', 'Dance'],
  ['DEBATE_OR_SPEECH', 'Debate/Speech'],
  ['ENVIRONMENTAL', 'Environmental'],
  ['FAMILY_RESPONSIBILITIES', 'Family Responsibilities'],
  ['FOREIGN_EXCHANGE', 'Foreign Exchange'],
  ['FOREIGN_LANGUAGE', 'Foreign Language'],
  ['JOURNALISM_OR_PUBLICATION', 'Journalism/Publication'],
  ['JUNIOR_R_O_T_C', 'Junior R.O.T.C'],
  ['LGBT', 'LGBT'],
  ['MUSIC_INSTRUNENTAL', 'Music:Instrumental'],
  ['MUSIC_VOCAL', 'Music:Vocal'],
  ['RELIGIOUS', 'Religious'],
  ['School_SPIRIT', 'School Spirit'],
  ['SCIENCE_OR_MATH', 'Science/Math'],
  ['STUDENT_GOVT_OR_POLITICS', 'Student Govt./Politics'],
  ['THEATER_OR_DRAMA', 'Theater/Drama'],
  ['WORT_PAID', 'Work(Paid)'],
  ['SOCIAL_JUSTICE', 'Social Justice'],
  ['INTERNSHIP', 'Internship'],
  ['RESEARCH', 'Research'],
  ['ROBOTICS', 'Robotics'],
  ['OTHER_CLUB_OR_ACTIVITY', 'Other Club/Activity']
]
export const activityTypeEnMap = [
  ['ACADEMY', 'academy'],
  ['ART', 'ART'],
  ['ATHLETICS_CLUB', 'Athletics:Club'],
  ['ATHLETICS_JV', 'Athletics:JV/Varsity'],
  ['CAREERORIENTED', 'Career Oriented'],
  ['VOLUNTEE', 'Community Service (Volunteer)'],
  ['COMPUTER_OR_TECHNOLOGY', 'Computer/Technology'],
  ['CULTURAL', 'Cultural'],
  ['DANCE', 'Dance'],
  ['DEBATE_OR_SPEECH', 'Debate/Speech'],
  ['ENVIRONMENTAL', 'Environmental'],
  ['FAMILY_RESPONSIBILITIES', 'Family Responsibilities'],
  ['FOREIGN_EXCHANGE', 'Foreign Exchange'],
  ['FOREIGN_LANGUAGE', 'Foreign Language'],
  ['JOURNALISM_OR_PUBLICATION', 'Journalism/Publication'],
  ['JUNIOR_R_O_T_C', 'Junior R.O.T.C'],
  ['LGBT', 'LGBT'],
  ['MUSIC_INSTRUNENTAL', 'Music:Instrumental'],
  ['MUSIC_VOCAL', 'Music:Vocal'],
  ['RELIGIOUS', 'Religious'],
  ['School_SPIRIT', 'School Spirit'],
  ['SCIENCE_OR_MATH', 'Science/Math'],
  ['STUDENT_GOVT_OR_POLITICS', 'Student Govt./Politics'],
  ['THEATER_OR_DRAMA', 'Theater/Drama'],
  ['WORT_PAID', 'Work(Paid)'],
  ['SOCIAL_JUSTICE', 'Social Justice'],
  ['INTERNSHIP', 'Internship'],
  ['RESEARCH', 'Research'],
  ['ROBOTICS', 'Robotics'],
  ['OTHER_CLUB_OR_ACTIVITY', 'Other Club/Activity']
]
// 领导力映射
export const leadershipCnMap = [['true', '是'], ['false', '否']]
export const leadershipEnMap = [['true', 'Yes'], ['false', 'No']]
// 参与时段映射
export const timeFrameCnMap = [
  ['SCHOOLYEAR', 'During school year'],
  ['SCHOOLBREAK', 'During school break'],
  ['ALLYEAR', 'all year']
]
export const timeFrameEnMap = [
  ['SCHOOLYEAR', 'During school year'],
  ['SCHOOLBREAK', 'During school break'],
  ['ALLYEAR', 'all year']
]

// 有意继续映射
export const isContinueCnMap = [['true', '是'], ['false', '否']]
export const isContinueEnMap = [['true', 'Yes'], ['false', 'No']]

// 熟练程度映射
export const proficiencyCnMap = [
  ['NATIVE', 'Native'],
  ['FLUENT', 'Fluent'],
  ['INTERMEDIATE', 'Intermediate/Beginner']
]
export const proficiencyEnMap = [
  ['NATIVE', 'Native'],
  ['FLUENT', 'Fluent'],
  ['INTERMEDIATE', 'Intermediate/Beginner']
]
// 是否专业训练映射
export const proTrainingCnMap = [['true', '是'], ['false', '否']]
export const proTrainingEnMap = [['true', 'Yes'], ['false', 'No']]
